import { Configuration, ConfigurationParameters } from "./generated-sources";
import {
  MerchantAuthLoginApi,
  MerchantAuthFirstLoginApi,
} from "./generated-sources/api";
import { Environment } from "@/services/environment";
import { MerchantAuthRepository } from "./repositories/MerchantAuthRepository";
import { MerchantAuthRepositoryImp } from "./implements/MerchantAuthRepositoryImp";

export class AuthServiceClient {
  private config: Configuration;
  public readonly merchantAuthLogin: MerchantAuthLoginApi;
  public readonly merchantAuthFirstLogin: MerchantAuthFirstLoginApi;

  constructor(cf: Configuration) {
    this.config = cf;
    this.merchantAuthLogin = new MerchantAuthLoginApi(cf, cf.basePath);
    this.merchantAuthFirstLogin = new MerchantAuthFirstLoginApi(
      cf,
      cf.basePath,
    );
  }
}

export const authServiceConfig: ConfigurationParameters = {
  basePath: Environment.hostApiAuthService,
};

export class AuthServiceHttpClient {
  public readonly merchantAuthRepository: MerchantAuthRepository;

  private static authServiceClient: AuthServiceClient;

  constructor(basePath?: string) {
    if (basePath) {
      authServiceConfig.basePath = basePath;
    }
    AuthServiceHttpClient.authServiceClient = new AuthServiceClient(
      new Configuration(authServiceConfig),
    );
    this.merchantAuthRepository = new MerchantAuthRepositoryImp(
      AuthServiceHttpClient.authServiceClient,
    );
  }
}
